// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cc2d8ca5","453":"7c741154","732":"3a5704d1","977":"81b01f8f"}[chunkId] + ".chunk.js";
};